import React, { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface Props {
  children: JSX.Element;
}

const AdminRoute: React.FC<Props> = ({ children }) => {
  const auth = useAuth();
  const user = auth?.user as { role?: string } | null;
  const isAdmin = user?.role === 'ADMIN';

  if (!isAdmin) {
    return <Navigate to="/notfound" replace />;
  }
  return children;
};

export default AdminRoute;
